import React, { useEffect, useState } from 'react';
import { InputMask } from '@react-input/mask';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import FornecedorModal from './modals/Fornecedor';
import Paginacao from '../../../components/utils/paginacao';

import { FaPlus, FaEdit, FaFilter } from 'react-icons/fa';

const Fornecedores = () => {
  const [error, setError] = useState(null);

  const [fornecedores, setFornecedores] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroEmail, setFiltroEmail] = useState('');
  const [filtroCnpj, setFiltroCnpj] = useState('');

  const [selectedFornecedor, setSelectedFornecedor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchFornecedores = async (currentPage) => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      const params = {
        page: currentPage,
        limit: limit,
        nome: filtroNome,
        email: filtroEmail,
        cnpj: filtroCnpj
      };

      const response = await api.get('/pessoas/fornecedores', { params });

      setFornecedores(response.data.fornecedores || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
      Swal.close();
    } catch (err) {
      Swal.close();
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    }
  };

  useEffect(() => {
    fetchFornecedores(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddFornecedor = () => {
    setSelectedFornecedor(null);
    setIsModalOpen(true);
  };

  const handleEditFornecedor = (fornecedor) => {
    setSelectedFornecedor(fornecedor);
    setIsModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchFornecedores(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
    setFiltroEmail('');
    setFiltroCnpj('');
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Fornecedores</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddFornecedor}>
                <FaPlus /> Adicionar Fornecedor
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-12">
              <label className="form-label fw-bold">Nome / Nome Fantasia</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">E-mail</label>
              <input
                type="email"
                autoComplete="off"
                placeholder="Digite o e-mail"
                value={filtroEmail}
                className="form-control"
                onChange={(e) => setFiltroEmail(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">CNPJ</label>
              <InputMask
                mask="__.___.___/____-__"
                replacement={{ _: /\d/ }}
                className="form-control"
                autoComplete="off"
                placeholder="00.000.000/0000-00"
                value={filtroCnpj}
                onChange={(e) => setFiltroCnpj(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Nome Fantasia</th>
                    <th>Razão Social</th>
                    <th>CNPJ</th>
                    <th>Celular</th>
                    <th>E-mail</th>
                    <th>Responsável</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {fornecedores.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        Nenhum fornecedor encontrado.
                      </td>
                    </tr>
                  ) : (
                    fornecedores.map((fornecedor) => (
                      <tr key={fornecedor.id}>
                        <td className="text-nowrap">{fornecedor.dadosFornecedor?.nome_fantasia || fornecedor.nome || '-'}</td>
                        <td className="text-nowrap">{fornecedor.dadosFornecedor?.razao_social || '-'}</td>
                        <td className="text-nowrap">{fornecedor.cnpj || '-'}</td>
                        <td className="text-nowrap">{fornecedor.celular || '-'}</td>
                        <td>{fornecedor.email || '-'}</td>
                        <td className="text-nowrap">{fornecedor.dadosFornecedor?.responsavel || '-'}</td>
                        <td className="text-nowrap text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditFornecedor(fornecedor)}
                            title="Editar fornecedor"
                          >
                            <FaEdit />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>

        </div>

        {isModalOpen && (
          <FornecedorModal
            fornecedor={selectedFornecedor}
            onClose={() => setIsModalOpen(false)}
            onFornecedorAtualizado={() => fetchFornecedores(currentPage)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Fornecedores;
